export const SW_URL = `https://service.jsdc.com.tw`; //service-worker

export const EndPoint = {
  Trail: {
    ALL: `${SW_URL}/Trails`,
  },
  AdvanceListing: {
    ALL: `${SW_URL}/AdvanceListing`,
  },
  Region: {
    Counties: `${SW_URL}/Region/counties`,
    Towns: `${SW_URL}/Region/towns`,
  },
};
